import { ArrowLeft, Home } from 'lucide-react'
import { Link, useNavigate, useParams } from 'react-router-dom'

import { useOrgStore } from '@/lib/store'
import { MpButton, MpPanel } from '@/ui/components'

interface NotFoundPageProps {
  recoveryOrgId?: string | null
}

export default function NotFoundPage({ recoveryOrgId }: NotFoundPageProps) {
  const navigate = useNavigate()
  const { orgId } = useParams()
  const activeOrgId = useOrgStore((state) => state.activeOrgId)
  const navigationOrgId = recoveryOrgId || activeOrgId || orgId
  const dashboardPath = navigationOrgId ? `/o/${navigationOrgId}/dashboard` : '/'

  return (
    <div className="grid min-h-[calc(100vh-8rem)] place-items-center px-4 py-8">
      <MpPanel className="w-full max-w-4xl space-y-6 px-5 py-8 sm:px-8 sm:py-10">
        <div className="flex items-end justify-center">
          <p className="relative z-10 text-[60px] font-semibold leading-none text-[var(--mph-accent)] sm:text-[72px]">
            404
          </p>
          <span className="mph-404-goose" aria-hidden="true">
            <span className="mph-404-goose__stage">
              <span className="mph-404-goose__figure">
                <span className="mph-404-goose__body" />
                <span className="mph-404-goose__wing" />
                <span className="mph-404-goose__neck" />
                <span className="mph-404-goose__head" />
                <span className="mph-404-goose__eye" />
                <span className="mph-404-goose__beak" />
                <span className="mph-404-goose__leg mph-404-goose__leg--left" />
                <span className="mph-404-goose__leg mph-404-goose__leg--right" />
                <span className="mph-404-goose__foot mph-404-goose__foot--left" />
                <span className="mph-404-goose__foot mph-404-goose__foot--right" />
              </span>
            </span>
          </span>
        </div>

        <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_280px] lg:items-end">
          <div className="space-y-3">
            <h1 className="text-2xl font-semibold text-[var(--mph-text-primary)] sm:text-[28px]">
              Сторінку не знайдено
            </h1>
            <p className="max-w-2xl text-sm leading-6 text-[var(--mph-text-secondary)]">
              Посилання може бути застарілим. Поверніться на головну сторінку або відкрийте потрібний розділ з меню.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <MpButton variant="secondary" onClick={() => navigate(-1)}>
              <ArrowLeft className="h-4 w-4" />
              Назад
            </MpButton>
            <MpButton asChild variant="primary">
              <Link to={dashboardPath}>
                <Home className="h-4 w-4" />
                На головну
              </Link>
            </MpButton>
          </div>
        </div>
      </MpPanel>
    </div>
  )
}
